import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

import LoadingIndicator from '../../components/LoadingIndicator.js';
import LoadingError from '../LoadingError.js';
import HeadingsTitleSearchResultsItem from './HeadingsTitleSearchResultsItem.js';
import NoSearchResults from '../../components/simple-search-results/NoSearchResults.js';
import WrongQueryError from '../simple-search-results/WrongQueryError.js';

//import img
import chevronDoubleLeft from '../../assets/icons/chevron-double-left.svg';

const HeadingsTitleSearchResults = ({ clang, isWrongQuery, searchKey, results, isLoading, isError}) => {
    const reduceByAdding = (arr) => {
        return arr.reduce(function(previousValue, currentValue) {
            return previousValue + currentValue;
        });
    };



    return (
        <div className="headings-results">
            {!isWrongQuery && isLoading && <LoadingIndicator />}
            {isWrongQuery && !isLoading && <WrongQueryError />}

            {!isWrongQuery && !isLoading && isError &&
                <LoadingError />}

            {!isWrongQuery && !isLoading && !isError &&
                <div>

                    {results.length > 0 &&
                        <ul className="headings-results__list">
                            {results.map((resultItem, index) =>
                                resultItem.headings && resultItem.headings.length > 0 &&
                                    <HeadingsTitleSearchResultsItem key={index} {...resultItem} reduceByAdding={reduceByAdding} searchKey={searchKey}/>)}
                        </ul>}

                    {results.length < 1 &&
                        <NoSearchResults />}

                    <Link to={'/headings/about'} className="back-button" title={lang[clang].back}>
                        <img src={chevronDoubleLeft} alt="" className="back-button__img" />
                        {lang[clang].back}
                    </Link>
                </div>}
        </div>
    );
};

HeadingsTitleSearchResults.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeadingsTitleSearchResults);



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsTitleSearchResults.js